<template>
  <v-form ref="form" @submit.prevent="submit">
    <v-text-field v-model="name" label="Name" :rules="[required]" />
    <v-text-field
      v-model="ssnnumber"
      label="Social Security Number"
      :rules="[required]"
    />
    <v-text-field
      v-model="driverlicense"
      label="Driver License Number"
      :rules="[required]"
    />
    <v-text-field v-model="email" label="Email" :rules="[required]" />
    <v-text-field
      v-model="phonenumber"
      label="Phone Number"
      :rules="[required]"
    />
    <v-select
      v-model="property"
      :rules="[required]"
      :items="properties"
      item-value="id"
      item-text="address"
      label="Property"
    />
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-btn raised class="primary" @click="onPickFile">
          Upload Image
        </v-btn>
        <input
          ref="fileInput"
          type="file"
          style="display: none"
          accept="image/*"
          @change="onFilePicked"
        >
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <img :src="imageUrl" height="150">
      </v-flex>
    </v-layout>

    <v-menu
      ref="dateOfBirth"
      v-model="isMenuOpen.avaliable"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="dateOfBirth"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <v-text-field
        slot="activator"
        label="Date of Birth"
        :value="dateOfBirth | formatDate"
        readonly
        :rules="[required]"
      />
      <v-date-picker v-model="dateOfBirth" no-title scrollable>
        <v-spacer />
        <v-btn flat color="primary" @click="isMenuOpen.avaliable = false">
          Cancel
        </v-btn>
        <v-btn
          flat
          color="primary"
          @click="$refs.dateOfBirth.save(dateOfBirth)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
    <v-menu
      ref="dateStartedRenting"
      v-model="isMenuOpen.listed"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="dateStartedRenting"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <v-text-field
        slot="activator"
        label="Date Started Renting"
        :value="dateStartedRenting | formatDate"
        readonly
        :rules="[required]"
      />
      <v-date-picker v-model="dateStartedRenting" no-title scrollable>
        <v-spacer />
        <v-btn flat color="primary" @click="isMenuOpen.listed = false">
          Cancel
        </v-btn>
        <v-btn
          flat
          color="primary"
          @click="$refs.dateStartedRenting.save(dateStartedRenting)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
    <v-layout row justify-space-around>
      <v-btn @click="$router.back(1)">
        Cancel
      </v-btn>
      <v-btn type="submit" color="primary">
        {{ tenantId ? 'Update' : 'Add' }}
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
import { storage } from 'firebase/app';
import 'firebase/storage';
import dayjs from 'dayjs';
import { pick } from 'lodash-es';
import { required } from '@/util';
import { db, getUid } from '@/plugins/firebase';

export default {
  name: 'TenantForm',
  filters: {
    formatDate: value => value && dayjs(value).format('MM/DD/YYYY'),
  },
  props: {
    tenantId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMenuOpen: {
        avaliable: false,
        listed: false,
      },
      dateOfBirth: null,
      dateStartedRenting: null,
      name: null,
      ssnnumber: null,
      driverlicense: null,
      email: null,
      phonenumber: null,
      image: null,
      imageUrl: '',
      property: null,
      properties: [],
    };
  },
  async created() {
    if (this.tenantId) {
      const toFetch = [];
      toFetch.push(
        storage()
          .ref(`tenants/${this.tenantId}`)
          .getDownloadURL(),
      );
      toFetch.push(
        db
          .collection('users')
          .doc(this.tenantId)
          .get(),
      );
      const [imageUrl, tenantSnap] = await Promise.all(toFetch);
      this.imageUrl = imageUrl;
      const tenant = tenantSnap.data();
      Object.assign(this, tenant);
      this.dateOfBirth = dayjs(tenant.dateOfBirth).format('YYYY-MM-DD');
      this.dateStartedRenting = dayjs(tenant.dateStartedRenting).format(
        'YYYY-MM-DD',
      );
    }
  },
  methods: {
    isCurrency: value => /^\d+(\.\d{0,2})?$/.test(value) || 'Please input a valid dollar amount',
    required,
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit('submit', this.image, {
        ...pick(this.$data, [
          'name',
          'dateOfBirth',
          'ssnnumber',
          'driverlicense',
          'email',
          'phonenumber',
          'property',
        ]),
        dateOfBirth: dayjs(this.dateOfBirth).valueOf(),
        dateStartedRenting: dayjs(this.dateStartedRenting).valueOf(),
      });
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const { files } = event.target;
      const fileReader = new FileReader();
      fileReader.onload = () => {
        this.imageUrl = fileReader.result;
      };
      fileReader.readAsDataURL(files[0]);
      [this.image] = files;
    },
  },
  firestore: {
    properties: db.collection('properties').where('admin', '==', getUid()),
  },
};
</script>

<style></style>
